import React, { useEffect } from "react";
import axios from "axios";
import Spinner from '../common/Spinner';

const ClickHome = ({ match, history }) => {
  
  useEffect(() => {
    async function fetchExistingID(id) {
      try {
        const result = await axios(`/api/click/${id}`);
        if (result.data.url) {
          window.location.replace(result.data.url);
        } else {
          history.replace('/game');
        }
      } catch (error) {
        console.error(error);
      }
    }

    const id = match.params.id;
    fetchExistingID(id);
  }, []);

  return(<Spinner />);
};

export default ClickHome;
